// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","value":"styles_value__ZUKbm","metric":"styles_metric__h82q7","postfix":"styles_postfix__482Sf","fadeIn":"styles_fadeIn__PZMZu"};